module.exports = __webpack_public_path__ + "img/icon_instagram_pencil.b3cf59e0.svg";